<template>
  <div id="sec-dining" class="pb-3 mb-4">
    <div class="px-3">
      <div class="ch-section-header mb-3">
        <h2 v-if="!isTitleSameAsTagline" class="heading-6-1 mb-0" style="letter-spacing:-0.3px">{{ pos.name }}</h2>
      </div>

      <!-- Featured banner -->
      <button
        @click="$emit('navigate', targetRoute)"
        class="ch-featured-banner w-100 radius-16 overflow-hidden d-flex mb-3 text-left p-0"
        type="button"
      >
        <div class="flex-grow-1 p-3">
          <p class="mb-1 text-16 lh-1-3 font-bold text-semi-dark">{{ pos.tagline || pos.name || 'In-room Dining' }}</p>
          <p class="mb-3 color-grey text-12 lh-1-5 font-regular">{{ pos.sub_tagline || 'Delivered straight to your villa' }}</p>
          <span class="ch-btn-primary px-3 py-2 d-inline-flex align-items-center rounded-50 text-12 font-bold ls-0-25">
            Order now <i class="simple-icon-arrow-right ml-1" style="font-size:10px"></i>
          </span>
        </div>
        <div
          class="ch-featured-img flex-shrink-0"
          :style="{ backgroundImage: bannerImage }"
        ></div>
      </button>
    </div>

    <!-- Best sellers -->
    <template v-if="products.length > 0">
      <p class="px-3 mb-2 text-10 font-bold ls-0-5 text-subcolor" style="text-transform:uppercase">Best sellers</p>
      <div class="ch-hscroll px-3">
        <div
          v-for="product in products"
          :key="product.id"
          class="ch-dining-card bg-white radius-16 flex-shrink-0"
        >
          <div class="ch-dining-card-img" :style="{ backgroundImage: 'url(' + (product.cover_image_url || product.image_url) + ')' }"></div>
          <div class="p-2">
            <p class="mb-1 text-13 lh-1-3 font-bold text-semi-dark">{{ product.name }}</p>
            <p v-if="product.description" class="mb-1 color-grey text-11 lh-1-5 font-regular ch-product-desc">{{ product.description }}</p>
            <p class="mb-0 text-13 font-bold" style="color:var(--merchant-text-color)">{{ formatCurrency(productPrice(product)) }}</p>
          </div>
        </div>
      </div>
      <div class="px-3 pt-3 text-center">
        <span
          @click="$emit('navigate', targetRoute)"
          class="ch-more-link text-13 font-bold cursor-pointer"
        >See all menu <i class="simple-icon-arrow-right" style="font-size:10px"></i></span>
      </div>
    </template>
  </div>
</template>

<script>
  import { formatCurrency } from '@/utils/index.js'

  export default {
    name: 'ConciergeDiningSection',

    props: {
      service: { type: Object, required: true },
    },

    computed: {
      pos() {
        return (this.service && this.service.merchant_pos) || {}
      },

      sectionLabel() {
        return this.pos.pos_type === 'RESTAURANT' ? 'RESTAURANT' : 'FOOD & DRINKS'
      },

      isTitleSameAsTagline() {
        var name = (this.pos.name || '').trim()
        var tagline = (this.pos.tagline || '').trim()
        return name !== '' && name === tagline
      },

      bannerImage() {
        var slider = (this.pos.slider && this.pos.slider.length > 0) ? this.pos.slider : []
        return slider.length > 0 ? 'url(' + slider[0].image_url + ')' : 'none'
      },

      targetRoute() {
        if (this.pos.pos_type === 'RESTAURANT') {
          return { name: 'PosHome', params: { pos_code: this.pos.code } }
        }
        return { name: 'ConciergeRoomDining' }
      },

      products() {
        var bestMenu = this.service && this.service.best_menu
        var fromBest = (bestMenu && bestMenu.product) || []
        if (fromBest.length > 0) return fromBest
        return (this.pos && this.pos.product) || []
      },
    },

    methods: {
      formatCurrency,

      productPrice(product) {
        function price(val) {
          return (val && val.parsedValue !== undefined) ? val.parsedValue : (val || 0)
        }
        if (product.variant_list && product.variant_list.length > 0) {
          var sorted = product.variant_list.slice().sort(function(a, b) {
            return price(a.price && a.price.price_sell_final_with_tax_service) -
                   price(b.price && b.price.price_sell_final_with_tax_service)
          })
          return price(sorted[0].price && sorted[0].price.price_sell_final_with_tax_service)
        }
        return product.price ? price(product.price.price_sell_final_with_tax_service) : 0
      },
    },
  }
</script>

<style scoped>
.ch-section-header { padding-top: 8px; }

.ch-btn-primary {
  background: var(--merchant-primary-color, #2B5F7A);
  color: #fff;
  border: none;
  cursor: pointer;
}

.ch-featured-banner {
  background: #fff;
  border: 1px solid #E0E8EF;
  cursor: pointer;
  color: #1C2B36;
  box-shadow: 0 1px 2px rgba(15,30,50,0.04), 0 4px 14px rgba(15,30,50,0.06);
}

.ch-featured-img {
  width: 120px;
  background-size: cover;
  background-position: center;
  flex-shrink: 0;
}

.ch-hscroll {
  display: flex;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  gap: 12px;
  padding-bottom: 4px;
}

.ch-hscroll::-webkit-scrollbar { display: none; }

.ch-dining-card {
  flex: 0 0 148px;
  border: 1px solid #E0E8EF;
  box-shadow: 0 1px 2px rgba(15,30,50,0.04), 0 4px 14px rgba(15,30,50,0.06);
  overflow: hidden;
}

.ch-dining-card-img {
  height: 110px;
  background-size: cover;
  background-position: center;
}

.ch-product-desc {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.ch-more-link {
  color: var(--merchant-primary-color, #2B5F7A);
}
</style>



// WEBPACK FOOTER //
// src/components/v2/ConciergeDiningSection.vue